import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ToolbarComponent } from "../../../shared/components/toolbar/toolbar.component";
import { RouterModule } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BillingService } from "../../services/billing.service";
import { TranslocoCurrencyPipe, TranslocoDatePipe } from "@jsverse/transloco-locale";
import { Observable } from "rxjs";
import { stripeAccount } from "../../model/stripe-account.model";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ToastService } from "../../../shared/services/toast.service";
import { IDropdownData } from "../../../shared/models/dropdownData.model";
import { UtilService } from "../../../shared/services/util.service";

@Component({
    selector: 'clp-stripe-account',
    styleUrls: ['./stripe-account.component.scss'],
    templateUrl: './stripe-account.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        CommonModule,
        ToolbarComponent,
        ReactiveFormsModule
    ],
    providers: [
        BillingService,
        ToastrService,
        UtilService
    ]
})

export class CreateStripeAccountComponent implements OnInit {
    private billingService = inject(BillingService);
    private toastService = inject(ToastService);
    private utilService = inject(UtilService);
    private translate = inject(TranslateService);

    public payments$!: Observable<string>;
    public account$!: Observable<stripeAccount>;
    public countries!: IDropdownData[];
    public selectedCountry!: string;
    showUpdateButton: boolean = false;
    showCreateButtons: boolean = false;

    updateForm!: FormGroup;

    ngOnInit(): void {
        this.countries = this.utilService.getCountryDropdownData();
        this.account$ = this.billingService.getStripeAccount();
        this.account$.subscribe();

        this.updateForm = new FormGroup({
            code: new FormControl('', [Validators.maxLength(30)])
        });
    }

    CreateStripeAccount() {
        this.payments$ = this.billingService.createStripeAccount(this.selectedCountry);
        this.payments$.subscribe(
            account => {

                if (account !== undefined && account !== null) {
                    window.location.reload();
                } else {
                    this.toastService.error(this.translate.instant('stripe.accountCreatedError'), '');
                }
            },
            error => {
                console.error("Error occurred:", error); // Log the error for debugging
                this.toastService.error(this.translate.instant('stripe.accountCreatedError'), '');
            }
        );
    }

    CompleteStripeAccount() {
        let link$ = this.billingService.getStripeAccountLink();
        link$.subscribe(link => {
            window.open(link, '_blank');
        });
    }

    ShowUpdateStripeAccount() {
        this.showUpdateButton = true;
    }

    UpdateStripeAccount(formValues: any) {
        if (!this.updateForm.invalid) {
            let return$ = this.billingService.updateStripeAccount(formValues.code);
            return$.subscribe(x => {
                if (x !== null && x !== undefined) {
                    this.showUpdateButton = false;
                    this.toastService.show(this.translate.instant('stripe.accountUpdated'), '');
                    this.account$ = this.billingService.getStripeAccount();
                }
            })
        }
    }

    RefreshAccount() {
        this.account$ = this.billingService.getStripeAccount();
        this.account$.subscribe();
    }

    sleep(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    selectCountry(event: Event): void {
        this.selectedCountry = (event.target as HTMLSelectElement).value;
        if (this.selectedCountry !== undefined && this.selectedCountry !== null && this.selectedCountry !== '' ) {
            this.showCreateButtons = true;
        } else {
            this.showCreateButtons = false;
        }
    }
}
